import axios from 'axios'
import config from '../config';

import { getQueryStringFromObject, getRequestHeaders } from './common.service';

const getWristbandCategoryList = async (query=null) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandCategory' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        const total = parseInt(response.headers['content-range'].split('/')[1], 10);
        return {categories: response.data, total: total};
    } catch (error) {
        return { error: error.message };
    }
}

const getCategoryDetails = async (category_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandCategory/' + category_id, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const createCategory = async (data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/wristbandCategory', data, { headers: headers });
        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const saveCategoryDetails = async (category_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v1/wristbandCategory/' + category_id, data, { headers: headers });
        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const deleteWristbandCategory = async (category_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.delete( config.apiUrl + '/v1/wristbandCategory/' + category_id, { headers: headers });

        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const hideWristbandCategory = async (category_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/hide', {}, { headers: headers });

        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const unhideWristbandCategory = async (category_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/unhide', {}, { headers: headers });

        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const importWristbandPackets = async (packets, category_id, importId) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/import', { packets: packets, importId: importId }, { headers: headers });
        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getWristbandPackets = async (query=null, category_id) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/packets' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        const total = parseInt(response.headers['content-range'].split('/')[1], 10);
        return {packets: response.data, total: total};
    } catch (error) {
        return { error: error.message };
    }
}

const deleteWristbandPacket = async (category_id, packet_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.delete( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/packets/' + packet_id, { headers: headers });
        } catch (error) {
            return {error: error.response.data};
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getPacketDetails = async (category_id, packet_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/packets/' + packet_id, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getPacketDetailsByShortId = async (short_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandPacket/shortId/' + short_id, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getWristbandsStatus = async (short_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandPacket/shortId/' + short_id + '/wristbandsStatus', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getNumberOfUsedClients = async (short_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandPacket/shortId/' + short_id + '/usedClientsCount', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getUsedPackets = async () => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandPacket/usedPackets', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getWristbands = async (query=null, category_id, packet_id) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/packets/' + packet_id + '/wristbands' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        const total = parseInt(response.headers['content-range'].split('/')[1], 10);
        return {wristbands: response.data, total: total};
    } catch (error) {
        return { error: error.message };
    }
}

const generateQrsFile = async (category_name, packets) => {
    // CSV headers
    const headers = ['Titre', 'Range', 'Count', 'ID'];
    
    // Build CSV content
    const rows = packets.map(p => {
        const range = p.minNumber && p.maxNumber ? p.minNumber + ' - ' + p.maxNumber : '-';
        return [
            category_name.toUpperCase(),
            range,
            p.quantity + " pcs",
            p.shortId
        ].join(',');
    });
    const csvContent = [headers.join(','), ...rows].join('\n');

    // Create a Blob
    const blob = new Blob([csvContent], { type: 'text/csv' });

    // Create a file-like object
    const file = new File([blob], 'etiquettes.csv', { type: 'text/csv' });

    return file;
}

const activatePackets = async (packetsData, entrance_id, amount, age) => {
    let response
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.apiUrl + '/v1/wristbandPacket/activate', { packetsData, entrance_id, amount, age }, { headers: headers });
    } catch (error) {
        return {error: error.response.data};
    }
    return response.data;
}

const unactivatePackets = async (packets) => {
    let response
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.apiUrl + '/v1/wristbandPacket/unactivate', { packets }, { headers: headers });
    } catch (error) {
        return {error: error.response.data};
    }
    return response.data;
}

const createNewPacket = async (category_id, uids) => {
    let response
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.apiUrl + '/v1/wristbandCategory/' + category_id + '/create_packet', { uids }, { headers: headers });
    } catch (error) {
        return {error: error.response.data};
    }
    return response.data;
}

const createSubPacket = async (packet_id, selected_wristbands) => {
    let response
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.apiUrl + '/v1/wristbandPacket/' + packet_id + '/createSubPacket', { selected_wristbands }, { headers: headers });
    } catch (error) {
        return {error: error.response.data};
    }
    return response.data;
}

export {
    getWristbandCategoryList,
    getCategoryDetails,
    createCategory, 
    saveCategoryDetails,
    deleteWristbandCategory,
    getUsedPackets,
    hideWristbandCategory,
    unhideWristbandCategory,
    importWristbandPackets,
    getWristbandPackets,
    deleteWristbandPacket,
    getWristbandsStatus,
    getPacketDetails,
    getWristbands,
    generateQrsFile,
    getPacketDetailsByShortId,
    activatePackets,
    getNumberOfUsedClients,
    unactivatePackets,
    createSubPacket,
    createNewPacket
}